// @flow
// Centralized occupancy definitions for use in select menus and label lookups

export const occupancies: Array<{ occupancyId: number, occupancy: string }> = [
  { occupancyId: 1, occupancy: 'Commercial Office' },
  { occupancyId: 2, occupancy: 'Education [k-12]: Elementary Schools' },
  { occupancyId: 3, occupancy: 'Education [k-12]: Middle Schools' },
  { occupancyId: 4, occupancy: 'Education [k-12]: High Schools' },
  { occupancyId: 5, occupancy: 'Healthcare' },
  { occupancyId: 6, occupancy: 'Hospitality' },
  { occupancyId: 7, occupancy: 'Multi-Unit Residential' },
  { occupancyId: 8, occupancy: 'Research' },
  { occupancyId: 9, occupancy: 'Retail' },
  { occupancyId: 10, occupancy: 'Warehouse' },
  { occupancyId: 11, occupancy: 'Single-Unit Residential' },
  { occupancyId: 12, occupancy: 'Parking Garage' },
];

// Map of occupancyId to label for quick lookup
export const occupancyLabelsById: { [string]: string } = Object.fromEntries(
  occupancies.map(({ occupancyId, occupancy }) => [String(occupancyId), occupancy])
);
